
import {AZIENDAREALTIME} from './AziendaRealTimeTypes'

export const changeAziendaRealTime = aziendaRealTime => {
    return {
        type: AZIENDAREALTIME,
        load: aziendaRealTime
    }
}

export const selectNewAziendaRealTime = (aziendaRealTime) => {

    return (dispatch) => {
        dispatch(changeAziendaRealTime(aziendaRealTime))
    }

}